export const priceFormatter = new Intl.NumberFormat(TPK.formats.lang, {
  style: 'currency',
  currency: TPK.formats.currency,
  currencyDisplay: 'narrowSymbol',
  maximumFractionDigits: TPK.formats.currency_decimals
});